module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "profileimg"
    }
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "box-func"
  }, [_c('div', {
    staticClass: "box-body"
  }, [_c('div', {
    staticClass: "clearfix"
  }), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-2 col-md-offset-1 col-sm-12 text-center"
  }, [(_vm.filepath !== '') ? _c('img', {
    staticClass: "img-employee img-circle",
    staticStyle: {
      "height": "150px",
      "width": "150px",
      "padding": "10px",
      "color": "black"
    },
    attrs: {
      "src": _vm.filepath
    }
  }) : _vm._e(), _vm._v(" "), (_vm.filepath === '') ? _c('img', {
    staticClass: "img-employee img-circle",
    staticStyle: {
      "height": "150px",
      "width": "150px",
      "padding": "10px",
      "color": "black"
    },
    attrs: {
      "src": "static/images/employee/no_image.png"
    }
  }) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6 col-md-offset-1 col-sm-12"
  }, [_c('hrms-dropzone', {
    ref: "hrmsDropzone",
    attrs: {
      "prefixFileName": _vm.codempid,
      "flgToggle": _vm.toggle,
      "flgRename": true,
      "maxFileSizeInMB": 5,
      "resizeMethod": "crop",
      "resizeWidth": "150",
      "resizeHeight": "150",
      "acceptedFileTypes": "image/*",
      "flgPreview": true
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "box-footer clear-padding",
    staticStyle: {
      "padding-top": "10px !important",
      "margin-top": "10px !important"
    }
  }, [_c('div', {
    staticClass: "col-xs-12 text-center clear-padding"
  }, [_c('button', {
    staticClass: "btn bg-color-skin",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.callSave()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-check-circle"
  }), _vm._v(_vm._s(_vm.app.button[_vm.app.nowLang]['save']))]), _vm._v(" "), _c('button', {
    staticClass: "btn bg-dark-gray",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.resetDropzone(false)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-refresh"
  }), _vm._v(_vm._s(_vm.app.button[_vm.app.nowLang]['clear']))])])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h4', {
    staticClass: "text-bold"
  }, [_c('i', {
    staticClass: "fa fa-camera"
  }), _vm._v(" Change Profile Image")])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-1451845f!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/profileimg/component.vue
// module id = 3572
// module chunks = 1